import { Alert, Button } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import React from 'react';
import { useShallowMergeSxProps } from '../hooks/useShallowMergeSxProps';
import I18n from '../i18n/I18n';

type ListViewInitialFilterAlertProps = {
    onClear: () => void;
    clearDisabled?: boolean;
    fullWidth?: boolean;
    sx?: SxProps<Theme>;
};

const LIST_VIEW_INITIAL_FILTER_ALERT_BASE_SX: SxProps<Theme> = {
    maxWidth: '100%',
    minHeight: (theme) => theme.spacing(4),
    alignItems: 'center',
    py: 0,
    '& .MuiAlert-message': {
        py: 0
    },
    '& .MuiAlert-action': {
        p: 0,
        alignItems: 'center'
    }
};

export const ListViewInitialFilterAlert = ({
    onClear,
    clearDisabled = false,
    fullWidth = false,
    sx
}: ListViewInitialFilterAlertProps) => {
    const resolvedAlertSxProps = useShallowMergeSxProps(
        [
            LIST_VIEW_INITIAL_FILTER_ALERT_BASE_SX,
            { width: fullWidth ? '100%' : 'fit-content', '& .MuiAlert-action': { ml: fullWidth ? undefined : 1 } }
        ],
        sx
    );

    return (
        <Alert
            severity="info"
            sx={resolvedAlertSxProps}
            action={
                <Button
                    size="small"
                    color="inherit"
                    variant="outlined"
                    onClick={onClear}
                    disabled={clearDisabled}
                    sx={{
                        minHeight: (theme) => theme.spacing(3)
                    }}
                >
                    <I18n token="list.initialFilter.alert.clear.button" />
                </Button>
            }
        >
            <I18n token="list.initialFilter.alert.message" />
        </Alert>
    );
};
